<!-- 开始聊天组件 -->
<template>
  <div>
    <div class="chat-card">
      <div class="ai-hi">
        <img class="robot-img" src="@/assets/images/robot-img.png" alt="" />
        <img class="hi-bg" src="@/assets/images/hi-bg-white.png" alt="" />
      </div>
      <div class="chat-text">
        XXX，你好呀！我是你的智能治疗师XXXX，欢迎开始我们的心理探索之旅。
      </div>
    </div>
    <!-- <div class="send-time">09月01日  16:29</div> -->
    <div class="next-btn">下一步</div>
  </div>
</template>

<script>

export default {
  name: 'StartChat',
  components: {
  },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 290px;
  border-radius: 12px 12px 12px 0px;
  padding: 18px 17px 6px 12px;
  background: #CFECFF;
  box-sizing: border-box;
  .ai-hi {
    width: 112px;
    height: 37px;
    margin-left: -4px;
    position: relative;
    overflow: hidden;
    .hi-bg {
      width: 112px;
      height: 28px;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 99;
    }
    .robot-img {
      position: absolute;
      top: 0px;
      left: 11px;
      width: 39px;
      height: 45px;
      z-index: 9;
    }
  }
  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
    margin-top: 6px;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9D9FA3;
  margin-top: 4px;
}
.next-btn {
  width: 112px;
  height: 30px;
  border-radius: 115px;
  border: 1.5px solid #DDDDDD;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0px;
  color: #222222;
  margin-bottom: 10px;
}
</style>
